<template>
	<nav class="navbar navbar-left navbar-top navbar-expand py-3">
		<div class="deco-line d-none d-md-block"></div>
		<div class="container">
			<router-link class="navbar-brand" to="/">
				<div class="d-flex align-items-center">
					<img
						class="ms-2 mt-1 me-2"
						src="../../assets/logo.svg"
						alt=""
						width="135"
					/>
				</div>
			</router-link>
			<ul
				class="navbar-nav navbar-nav-icons ms-auto flex-row align-items-center"
			>
				<button
					@click="nav_switch"
					class="btn navbar-toggler-humburger-icon navbar-toggler"
					type="button"
					data-bs-toggle="collapse"
					data-bs-target="#navbarVerticalCollapse"
					aria-controls="navbarVerticalCollapse"
					aria-expanded="false"
					aria-label="Toggle Navigation"
				>
					<span class="navbar-toggle-icon">
						<span class="toggle-line"></span>
					</span>
				</button>
			</ul>
		</div>
	</nav>
</template>

<script>
import { mapGetters } from "vuex";

export default {
	data() {
		return {};
	},

	computed: {
		...mapGetters(["navTopSwitch"]),
	},

	methods: {
		nav_switch() {
			if (this.navTopSwitch == "") {
				this.$store.commit("navTopSwitch", "show");
			} else {
				this.$store.commit("navTopSwitch", "");
			}
		},
	},
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 1200px) {
	nav.navbar.navbar-left.navbar-top.navbar-expand {
		background-color: var(--falcon-body-bg);
		.container {
			padding: 0;
		}
	}
}
</style>
